import { Pen } from "lucide-react";

import React from "react";

function UpdateMode() {
  return (
    <div
      className="flex items-center justify-between 
                rounded-xl 
                border border-yellow-300 
                bg-yellow-50 
                px-4 py-3 
                shadow-sm"
    >
      {/* Left Section */}
      <div className="flex items-center gap-3">
        <div
          className="flex items-center justify-center 
                    w-9 h-9 
                    rounded-full 
                    bg-yellow-100 
                    text-yellow-600"
        >
          <Pen className="w-4 h-4" />
        </div>

        <div>
          <p className="text-sm font-semibold text-yellow-800">
            Permissions already created
          </p>
          <p className="text-xs text-yellow-600">
            You are currently editing existing permissions.
          </p>
        </div>
      </div>

      {/* Mode Badge */}
      <span
        className="text-xs font-medium 
                   px-3 py-1 
                   rounded-full 
                   bg-yellow-500 
                   text-white 
                   shadow-sm"
      >
        Edit Mode
      </span>
    </div>
  );
}

export default UpdateMode;
